module.exports = __webpack_public_path__ + "img/support.8323b967.png";